import { Navigate, Route, Routes } from 'react-router-dom';

import CustomerDashboard from '../pages/customer/CustomerDashboard.jsx';
import CustomerFeedback from '../pages/customer/CustomerFeedback';
import CustomerLayout from '../components/layout/CustomerLayout';
import CustomerProfile from '../pages/customer/CustomerProfile';
import MembershipDashboard from '../components/customer/MembershipDashboard';
import SubscriptionDashboard from '../components/customer/SubscriptionDashboard';
import SubscriptionPage from '../pages/SubscriptionPage';
import MembershipSuccess from '../pages/MembershipSuccess.jsx';
import RateVendor from '../pages/customer/RateVendor';
import InspectionsPage from '../pages/customer/InspectionsPage';
import ScheduleInspectionPage from '../pages/customer/ScheduleInspectionPage';
import PropertyListPage from '../pages/customer/PropertyListPage';
import JobDetailsPage from '../pages/jobs/JobDetailsPage';
import React from 'react';

const CustomerRoutes = () => {
  console.log('CustomerRoutes component loaded');
  return (
    <CustomerLayout>
      <Routes>
        {/* Dashboard */}
        <Route path="/" element={<CustomerDashboard />} />
        <Route path="/dashboard" element={<CustomerDashboard />} />
        
        {/* Job Management - Redirect to feedback page */}
        <Route path="/jobs" element={<Navigate to="/feedback" replace />} />
        <Route path="/jobs/:jobId" element={<JobDetailsPage />} />
        
        {/* Rating & Feedback */}
        <Route path="/feedback" element={<CustomerFeedback />} />
        <Route path="/rate-vendor/:jobId" element={<RateVendor />} />
        
        {/* Subscription Plans */}
        <Route path="/membership" element={<Navigate to="/subscription" replace />} />
        <Route path="/membership/plans" element={<SubscriptionPage />} />
        <Route path="/subscription" element={<SubscriptionPage />} />
        <Route path="/subscription/dashboard" element={<SubscriptionDashboard />} />
        {/* Redirect membership dashboard to subscription dashboard */}
        <Route path="/membership/dashboard" element={<Navigate to="/subscription/dashboard" replace />} />
        <Route path="/membership/dashboard" element={<MembershipDashboard />} />
        <Route path="/membership/success" element={<MembershipSuccess />} />
        
        {/* Profile */}
        <Route path="/profile" element={<CustomerProfile />} />
        
        {/* Properties */}
        <Route path="/properties" element={<PropertyListPage />} />
        
        {/* Inspections */}
        <Route path="/inspections" element={<InspectionsPage />} />
        <Route path="/inspections/:id/schedule" element={<ScheduleInspectionPage />} />
        
        {/* Redirect any other routes to dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </CustomerLayout>
  );
};

export default CustomerRoutes;